import React from 'react'
import { LoadingOverlay, Stack, Switch, Table, Title } from '@mantine/core'
import { useGetCommandsQuery, useUpdateCommandMutation } from './hooks'

export const TableauAdmin = () => {
    const { data: commands, isLoading } = useGetCommandsQuery()
    const { mutate: handleUpdateCommand, isLoading: updatePending } = useUpdateCommandMutation()

    const commandsFound = !!(commands && Object.keys(commands).length)

    return (
        <Stack p={30}>
            <Title order={4}>Tableau Admin</Title>
            <LoadingOverlay visible={isLoading} />

            { !isLoading && !commandsFound &&
            <Title order={5} ta='center'>No Commands Found</Title>}

            { commandsFound && Object.keys(commands).length &&
            <Table style={{ fontSize: 14 }} striped>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th w='100%'>Command</Table.Th>
                        <Table.Th w='100%'>Enabled</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {Object.entries(commands).map(([command, enabled]: [string, boolean]) => (
                        <Table.Tr key={command}>
                            <Table.Td w='100%'>{command}</Table.Td>
                            <Table.Td w='100%'>
                                <Switch
                                    checked={enabled}
                                    disabled={updatePending}
                                    onChange={() => handleUpdateCommand({ command, enabled: !enabled })}
                                />
                            </Table.Td>
                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table> }
        </Stack>
    )
}
